function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 9.7,
  stroke: "#020810",
  strokeWidth: 1.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 15.9633V8.43785C13.5 8.17797 13.5848 7.95198 13.7544 7.77119C13.924 7.5904 14.136 7.5 14.3799 7.5C14.6237 7.5 14.8357 7.5904 15.0053 7.77119C15.1749 7.95198 15.2597 8.17797 15.2597 8.43785V15.387L19.0654 17.7486C19.2774 17.8842 19.4046 18.0763 19.4682 18.3249C19.5318 18.5734 19.5 18.8107 19.3728 19.0254C19.2032 19.3418 18.9488 19.5 18.6095 19.5C18.4293 19.5 18.2809 19.4548 18.1643 19.3644L14.1148 16.8446C13.9346 16.7881 13.7862 16.6751 13.6696 16.5169C13.553 16.3588 13.5 16.178 13.5 15.9633Z",
  fill: "#020810"
});

var SvgPendingPostsIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPendingPostsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pending-posts-icon.1e43756a.svg";
export { ForwardRef as ReactComponent };